/**
 * Iniciais para avatar: primeira letra do primeiro nome + primeira do último sobrenome.
 * Um único token usa as duas primeiras letras desse nome.
 */
export function initialsFromFullName(name) {
    if (name == null || typeof name !== 'string') return '—';
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '—';
    if (parts.length === 1) {
        const w = parts[0];
        if (w.length <= 1) return w.toUpperCase();
        return (w.charAt(0) + w.charAt(1)).toUpperCase();
    }
    const first = parts[0].charAt(0);
    const last = parts[parts.length - 1].charAt(0);
    return (first + last).toUpperCase();
}
